import Papa from 'papaparse';
import { saveAs } from 'file-saver';

export default function downloadCDRCSV(items, filename) {

    const headers = [
        "Country",
        "MobileNo",
        "VMN",
        "Trans_id",
        "DID",
        "MissedCall_Date",
        "MissedCall_Time",
        "Contestant_name",
        "status"
    ];
    
    let jsonObject = items.map(item => {
        let row = {};
        headers.forEach(header => {
            row[header] = item[header];
        });
        return row;
    });

    let csv = Papa.unparse({
        fields: headers,
        data: jsonObject
    });

    let blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, filename + '.csv');
}